/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  ScDataSources,
  ScDataVersion,
  Version
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary SC Data Sources
 */
export const scDataSources = (

 signal?: AbortSignal
) => {


      return axiosClient<ScDataSources>(
      {url: `/sc-data/sources`, method: 'GET', signal
    },
      );
    }




export const getScDataSourcesQueryKey = () => {
    return [
    'sc-data','sources'
    ] as const;
    }


export const getScDataSourcesQueryOptions = <TData = Awaited<ReturnType<typeof scDataSources>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataSources>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getScDataSourcesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scDataSources>>> = ({ signal }) => scDataSources(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scDataSources>>, TError, TData>
}

export type ScDataSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof scDataSources>>>
export type ScDataSourcesQueryError = ErrorType<unknown>


/**
 * @summary SC Data Sources
 */

export function useScDataSources<TData = Awaited<ReturnType<typeof scDataSources>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataSources>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScDataSourcesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary SC Data Version
 */
export const scDataVersion = (

 signal?: AbortSignal
) => {


      return axiosClient<ScDataVersion>(
      {url: `/sc-data/version`, method: 'GET', signal
    },
      );
    }




export const getScDataVersionQueryKey = () => {
    return [
    'sc-data','version'
    ] as const;
    }


export const getScDataVersionQueryOptions = <TData = Awaited<ReturnType<typeof scDataVersion>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataVersion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getScDataVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof scDataVersion>>> = ({ signal }) => scDataVersion(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scDataVersion>>, TError, TData>
}

export type ScDataVersionQueryResult = NonNullable<Awaited<ReturnType<typeof scDataVersion>>>
export type ScDataVersionQueryError = ErrorType<unknown>


/**
 * @summary SC Data Version
 */

export function useScDataVersion<TData = Awaited<ReturnType<typeof scDataVersion>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scDataVersion>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScDataVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Version of Fleetyards
 */
export const version = (

 signal?: AbortSignal
) => {


      return axiosClient<Version>(
      {url: `/version`, method: 'GET', signal
    },
      );
    }




export const getVersionQueryKey = () => {
    return [
    'version'
    ] as const;
    }


export const getVersionQueryOptions = <TData = Awaited<ReturnType<typeof version>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof version>>> = ({ signal }) => version(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>
}

export type VersionQueryResult = NonNullable<Awaited<ReturnType<typeof version>>>
export type VersionQueryError = ErrorType<unknown>


/**
 * @summary Version of Fleetyards
 */

export function useVersion<TData = Awaited<ReturnType<typeof version>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof version>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






